import moment from "moment";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { db } from "../components/Firebase";

const Notes = () => {
  const [notes, setNotes] = useState([]);

  let navigate = useNavigate();
  //console.log("notes", notes);
  useEffect(() => {
    getAllNotes();
  }, []);

  const getAllNotes = async () => {
    db.collectionGroup("notes")
      //   .orderBy("createdAt", "asc")
      .get()
      .then((docs) => {
        let newNotes = [];
        docs.forEach((doc) => {
          newNotes.push({ ...doc.data(), id: doc.id });
        });
        setNotes([...newNotes]);
      })
      .then((data) => {
        //console.log("object", notes);
      })
      .catch((e) => {
        // //console.log("error");
        // //console.log(e);
      });
  };
  return (
    <div class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-12" style={{ paddingBottom: "40px" }}>
        <h1 style={{ textAlign: "center" }}>Notes</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" style={{height: "400px", overflowY: 'scroll'}}>
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Title</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {notes.sort((a,b)=>moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()).map((i) => {
              return (
            <tr onClick={() => {navigate("notesDetails", { state: { item: i } }); }}>
              <td>{i.title}</td>
              <td>{i.status}</td>
              <td>{i?.createdAt}</td>
            </tr>
            );
            })}
          </tbody>
        </table>
      </div>
      <div class="col-md-6">
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default Notes;
